const LectorDashboard = () => {
    return (
        <div>
            <h1>Dashboard</h1>
        </div>
    )
}

export default LectorDashboard